import React, { Component } from "react";
import classnames from "classnames";
import { FormGroup } from "react-bootstrap";
import Select from "react-select";
import arrowUp from "../../../assets/images/arrow-up.svg";
import arrowDown from "../../../assets/images/arrow-down.svg";
import styles from "./Select2.scss";
import "react-select/dist/react-select.css";

class Select2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: false
    };
    this.onChange = this.onChange.bind(this);
    this.arrowRenderer = this.arrowRenderer.bind(this);
  }

  onChange(value) {
    this.props.input.onChange(value);
    if (this.props.onSelectChange) {
      this.props.onSelectChange(value);
    }
  }

  arrowRenderer() {
    return this.state.isOpened ? (
      <img src={arrowUp} className={styles.arrow} />
    ) : (
      <img src={arrowDown} className={styles.arrow} />
    );
  }

  render() {
    const {
      input,
      meta: { touched, error, warning, valid },
      options,
      placeholder,
      valueKey,
      labelKey,
      name,
      isLoading,
      disabled,
      value,
      defaultValue
    } = this.props;

    const validationState =
      (touched && valid && "success") ||
      (touched && error && "error") ||
      (touched && warning && "warning") ||
      null;

    return (
      <FormGroup validationState={validationState}>
        <Select
          value={defaultValue || value || input.value}
          onChange={this.onChange}
          onBlur={() => input.onBlur(input.value)}
          options={options}
          placeholder={placeholder}
          name={name}
          simpleValue={true}
          clearable={false}
          menuContainerStyle={{ zIndex: 999 }}
          searchable={false}
          labelKey={labelKey || "value"}
          id={valueKey || "id"}
          valueKey={valueKey || "id"}
          arrowRenderer={this.arrowRenderer}
          onOpen={() => this.setState({ isOpened: true })}
          onClose={() => this.setState({ isOpened: false })}
          className={classnames(styles.sectionTest)}
          isLoading={isLoading || false}
          disabled={disabled || false}
        />
      </FormGroup>
    );
  }
}

export default Select2;



// WEBPACK FOOTER //
// ./src/components/common/select/Select2.js